module.exports = __webpack_public_path__ + "static/img/2.433075a5.png";